import { render, staticRenderFns } from "./notificationView.vue?vue&type=template&id=f9c0ebbc&scoped=true&"
import script from "./notificationView.vue?vue&type=script&lang=js&"
export * from "./notificationView.vue?vue&type=script&lang=js&"
import style0 from "./notificationView.vue?vue&type=style&index=0&id=f9c0ebbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9c0ebbc",
  null
  
)

export default component.exports